import ProductPageBreadcrumbs from "theme/components/productPage/Breadcrumbs";
import Grid from "theme/layouts/Grid";
import PageWrapper from "theme/components/wrappers/PageWrapper";
import ProductPageContainer from "core-web/containers/ProductPageContainer";
import ProductVideos from "theme/views/Product/ProductVideos";
import PropTypes from "prop-types";
import React from "react";
import SkeletonMediaGallery from "theme/components/skeletons/MediaGallery";
import SkeletonTopRight from "theme/components/skeletons/ProductPageTopRight";
import ViewsLoading from "theme/views/ViewsLoading";
import loadable from "@loadable/component";
import { useSelector } from "react-redux";

const MediaGallery = loadable(() => import("./MediaGallery"), {
    fallback: <SkeletonMediaGallery />,
});
const ProductInformation = loadable(() => import("./ProductInformation"), {
    fallback: <SkeletonTopRight />,
});

const ProductPage = ({
    bestHistoricalPrice = null,
    isExpired,
    isInStock,
    onQuantityChange,
    onVariantChange,
    product,
    qtyBreaks,
    quantity,
    selectedProduct,
    selectedProductVariants,
    variants,
    totalPricing,
    isQuantityPackage,
    relations,
}) => {
    const youtubeVideos = useSelector(({ page }) => page.data.product?.files || []).filter(
        ({ code }) => code === "wallmek_yt_video",
    );

    return (
        <PageWrapper isProductView>
            <ProductPageBreadcrumbs currentProduct={product.name} py="16px" />
            <Grid as="section" columns={["1", null, null, null, "12"]} columnGap="48px" mb="64px">
                <MediaGallery
                    product={product}
                    selectedProduct={selectedProduct}
                    selectedProductVariants={selectedProductVariants}
                    gridColumn={["1 / -1", null, null, null, "span 7", "span 8"]}
                />
                <ProductInformation
                    gridColumn={["1 / -1", null, null, null, "span 5", "span 4"]}
                    bestHistoricalPrice={bestHistoricalPrice}
                    includedProducts={product.included_products}
                    isQuantityPackage={isQuantityPackage}
                    inStock={isInStock}
                    isExpired={isExpired}
                    product={product}
                    qtyBreaks={qtyBreaks}
                    quantity={quantity}
                    variants={variants}
                    selectedProduct={selectedProduct}
                    selectedProductVariants={selectedProductVariants}
                    selectProductVariantCallback={onVariantChange}
                    totalPricing={totalPricing}
                    relations={relations}
                    onQuantityChange={onQuantityChange}
                />
            </Grid>
            {!!youtubeVideos?.length && <ProductVideos youtubeVideos={youtubeVideos} />}
        </PageWrapper>
    );
};

ProductPage.propTypes = {
    bestHistoricalPrice: PropTypes.number,
    isExpired: PropTypes.bool.isRequired,
    isInStock: PropTypes.bool.isRequired,
    isQuantityPackage: PropTypes.bool.isRequired,
    onQuantityChange: PropTypes.func.isRequired,
    onVariantChange: PropTypes.func.isRequired,
    product: PropTypes.object.isRequired,
    qtyBreaks: PropTypes.array.isRequired,
    quantity: PropTypes.number.isRequired,
    relations: PropTypes.array.isRequired,
    selectedProduct: PropTypes.object.isRequired,
    selectedProductVariants: PropTypes.object.isRequired,
    totalPricing: PropTypes.object.isRequired,
    variants: PropTypes.array.isRequired,
};

export default () => <ProductPageContainer shouldFetchRelations loading={ViewsLoading} render={ProductPage} />;
